// @flow

import React from 'react';

class ToggleItem extends React.Component {

  componentDidMount() {
    let checkBoxes = document.getElementsByClassName('check-box');
    [].forEach.call(checkBoxes, (item) => {
      let label = document.createElement('label');
      label.setAttribute('for', item.querySelector('input').getAttribute('id'));
      item.appendChild(label);
    });
  }

  render() {
    const { translate, mainParam, id, labelMain, contact, changeToggle, icon } = this.props;

    return (
      <div className="col-xs-6">
        <div className={`js-selected setbox-trigger set-box ${mainParam ? 'checked' : ''}`}>
          <div className="top">
            <div className="ico">
              <div className={`settings-area--ico settings-area--ico-${icon}`} />
            </div>
            <p className='js-contact phone-box'>{contact}</p>
          </div>
          <div className="bottom">
            <label className="js-label" htmlFor={`lbl-00${id}`}>
              {translate('settings.notification_is')}
              &nbsp;
              <span className="checked-txt">
                  {translate('settings.active')}
                </span>
                <span className="nochecked-txt">
                  {translate('settings.disabled')}
                </span>
                .
              </label>
          </div>
          <div className="check-box">
            <input
              className='js-test-checkbox js-toggle'
              id={`lbl-00${id}`}
              onChange={(e) => changeToggle(e, labelMain)}
              type="checkbox"
              checked={mainParam ? 'checked' : ''}
            />
          </div>
        </div>
      </div>
    )
  }

}

export default ToggleItem;



// WEBPACK FOOTER //
// ./src/components/main/settings/toggleItem.js